import headerAnalytics from 'header.analytics';
import * as thdcustomer from 'thd-customer';
import utils from '../shared/utils';
import '../shared/sv-hover-intent';

const taskLinks = {};
const privateMethods = {};

taskLinks.config = {
  taskLinkSelector: '.TaskLinks__link',
  eventName: 'header.tasklinks'
};

privateMethods.triggerHoverintent = function _triggerHoverintent(element) {
  document.dispatchEvent(new CustomEvent('hoverintent', {
    detail: {
      element
    }
  }));
  document.dispatchEvent(new Event('closeAllMenus'));
};

privateMethods.removeB2XLinks = function _removeB2XLinks () {
  if (thdcustomer.default.isB2XCustomer) {
      document.querySelector('#taskLinkPro')?.remove();
      document.querySelector('#taskLinkFav')?.remove();
      document.querySelector('#headerOrderStatus')?.remove();
  }
  else {
      document.querySelector('#b2xheaderOrderStatus')?.remove();
  }
    document.querySelector('#TasklinkList')?.classList.remove('u--hide');
};

privateMethods.logInteraction = (text) => {
  headerAnalytics.logEvent('header click', ['header', 'task links', text].join('>'));    
};

taskLinks.getPrivateMethods = () => privateMethods;

taskLinks.init = function _init (config) {
  let taskConfig = (config || taskLinks.config);
  privateMethods.removeB2XLinks();
  let callbackFunction = () => {
    privateMethods.logInteraction(el.innerHTML.toLowerCase());
  };

  utils.addListenerToAll('click', taskConfig.taskLinkSelector, callbackFunction);
  utils.addListenerToAll('touchend', taskConfig.taskLinkSelector, callbackFunction);
  
  /**
   * Replacement for jquery hoverIntent plugin used below
   * Get top-level items from a dropdown menu, then
   * Set actions for mouse over and mouse leave
   */
  let HoverIntent = new SV.HoverIntent(document.querySelectorAll(taskConfig.taskLinkSelector), {
    onEnter: function (targetItem) {
      privateMethods.triggerHoverintent(targetItem);
    },
    onExit: () => {}
  });
};

export default taskLinks;
